import { PassportDeviceInformation } from "services/report/passports/PassportService";
import { createDateLabel } from "utils/format";

export const getPassportHeading = (deviceInformation?: PassportDeviceInformation): string | undefined =>
    [deviceInformation?.model, deviceInformation?.manufacturer].filter(Boolean).join(" - ") || undefined;

export const getPassportIdentifiers = (
    t: (key: string) => string,
    deviceInformation?: PassportDeviceInformation,
    lastProcessed?: string
): string[] =>
    [
        deviceInformation?.imei && `${t("DevicePassport.panel.deviceInformation.imei")}: ${deviceInformation.imei}`,
        deviceInformation?.imei_two &&
            `${t("DevicePassport.panel.deviceInformation.imei_two")}: ${deviceInformation.imei_two}`,
        deviceInformation?.serial &&
            `${t("DevicePassport.panel.deviceInformation.serial")}: ${deviceInformation.serial}`,
        lastProcessed && `${t("DevicePassport.lastProcessed")}: ${createDateLabel(lastProcessed)}`,
    ].filter((identifier): identifier is string => Boolean(identifier));
